export function checkIfInsightsSupported(fig, SUPPORTED_TRACE_TYPES) {
    if (fig.data === undefined) return;
    if (fig.data.length === 0) return;

    const UNSUPPORTED_FIG_MESSAGE = "Please refer to the documentation on how to use manual insights with unsupported figures."
    // Trace types
    for (let i = 0; i < fig.data.length; i++) {
        const data = fig.data[i];
        if (!SUPPORTED_TRACE_TYPES.includes(data.type)) {
            throw new Error(
                `Figure contains a ${data.type} trace (trace no. ${i + 1}), which is not yet supported by the API. Supported trace types: ${SUPPORTED_TRACE_TYPES} ${UNSUPPORTED_FIG_MESSAGE}`
            );
        }
    }

    // Remove figures with various traces
    const traces = fig.data.map((data) => data.type);
    if (new Set(traces).size > 1) {
        throw new Error(
            `Figure contains multiple trace types: ${[...new Set(traces)]}. Currently only figures with one trace type are supported ${UNSUPPORTED_FIG_MESSAGE}`
        );
    }

    // Data size (rough approximation)
    let totalData = 0;
    for (const data of fig.data) {
        if (data.x) {
            totalData += data.x.length || 0;
        }
        if (data.y) {
            totalData += data.y.length || 0;
        }
    }
    if (totalData > 2000) {
        throw new Error(
            `Figure has ${totalData} data points. Maximum supported data points is 2000 ${UNSUPPORTED_FIG_MESSAGE}`
        );
    }

    // Facets
    for (const data of fig.data) {
        if (data.xaxis && data.yaxis) {
            const xaxis = data.xaxis;
            const yaxis = data.yaxis;

            const is_valid_axis = (axis, prefix) =>
                typeof axis === 'string' && axis.startsWith(prefix) && axis.slice(1).match(/^\d+$/);

            if (is_valid_axis(xaxis, 'x') && is_valid_axis(yaxis, 'y')) {
                throw new Error(
                    `Figures with facets/subplots are currently not supported ${UNSUPPORTED_FIG_MESSAGE}`
                );
            }
        }
    }
}